import React from "react";
import useSearchParamsCustom from "../hooks/useSearchParamsCustom";

function CategoryDropdown({ categories, onCategorySelect, categoryName }) {
  const { getSearchParam } = useSearchParamsCustom();
  return (
    <div className="bg-gray-400 inline-block rounded border-none">
      <div className="grid grid-cols-[repeat(1,1fr)] h-auto rounded gap-2 w-[22rem] z-10 px-6 py-4">
        {categories &&
          categories.map((category) => (
            <button
              key={category}
              type="button"
              onClick={() => onCategorySelect(category, categoryName)}
              className={
                getSearchParam(categoryName)?.includes(category)
                  ? "h-9 flex flex-row justify-center items-center text-[0.85rem] font-bold cursor-pointer m-0 p-0 rounded-[0.625rem] bg-black text-white"
                  : "h-9 flex flex-row justify-center items-center bg-white text-black text-[0.85rem] font-bold cursor-pointer m-0 p-0 rounded-[0.625rem]"
              }
            >
              {category}
            </button>
          ))}
      </div>
    </div>
  );
}

export default CategoryDropdown;
